import { Card, CardContent, CardTitle } from "@/components/ui/card"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart"
import { LabelList, Pie, PieChart } from "recharts"
import axiosInstance from "@/utils/axiosInstance"
import { useEffect, useState } from "react"

const chartConfig = {
    order_type: {
        label: "Type",
        color: "red"
    },
    count: {
        label: "Count",
        color: 'red'
    }
}

const statusColor = {
    transfer: '#555',
    tour: '#444'
}

const OrdersByGroup = ({ range }: { range: { startDate: Date, endDate: Date } }) => {
    const [chartData, setChartData] = useState([])

    useEffect(() => {
        const unsub = async () => {
          const {data} = await axiosInstance.get(`/reports/orders-by-type`, {
             params: {
                        startDate: range.startDate.toISOString().split("T")[0],
                        endDate: range.endDate.toISOString().split("T")[0],
                    }
          })
          
          const transformed = data.map((item: {order_type: 'tour' | 'transfer', count: number}) => ({
                    ...item,
                    fill: statusColor[item.order_type],
                }));

                setChartData(transformed);
          
        }
    
        unsub()
    }, [range])

    return (
        <Card className="max-w-full cursor-pointer">
            <CardContent>
                <CardTitle>Orders by type</CardTitle>
                <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
                    <PieChart accessibilityLayer>
                        <ChartTooltip content={<ChartTooltipContent nameKey="count" hideLabel />} />
                        <Pie data={chartData} dataKey="count" fill="var(--color-count)" radius={100}>
                            <LabelList dataKey="order_type" className="fill-background" />
                        </Pie>
                    </PieChart>
                </ChartContainer>
            </CardContent>
        </Card>
    )
}

export default OrdersByGroup